var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RecordingsList',{staticClass:"mt-3",attrs:{"sessionId":_vm.sessionId,"dark":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }